<template>
  <div class="a4">
    <nav-header></nav-header>
    <div class="container">
      <!-- banner -->
      <div class="banner">
        <img src="/imgs/ct.jpg" alt="" />
      </div>
      <!-- 主容器，左右布局开始 -->
      <div class="index-box">
        <!-- 左侧 -->
        <div class="index-l">
          <!-- 资讯区块2 -->
          <ac6 @click="goDays(item.methods, item.id)"></ac6>
        </div>
        <!-- 右侧 -->
        <div class="index-r">
          <!-- 资讯5 区块 -->
          <ac5></ac5>
          <!-- 文章列表 -->
          <ac4></ac4>
        </div>
      </div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
// import ac2 from "./../components/ac2";
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
import ac5 from "./../components/ac5";
import ac4 from "./../components/ac4";
import ac6 from "./../components/a6";
export default {
  name: "a4",
  data() {
    return {
      msrc: "/mock/info.json",
      mtitle: "行业资讯",
    };
  },
  components: {
    // ac2,
    ac5,
    ac4,
    ac6,
    NavFooter,
    NavHeader,
  },
  methods: {
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { id: id },
      });
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
      }
      // 未登录
      if (this.state !== 0) {
        alert("请注册购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.a4 {
  width: 100%;
  margin-top: 100px;
  position: relative;
  .container {
    height: 100%;
    .banner {
      width: 100%;
      height: 400px;
      margin: 20px auto;
      background-color: pink;
    }
    // 主容器
    .index-box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      // 左侧
      .index-l {
        width: 70%;
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;
        // background-color: pink;
      }
      // 右侧
      .index-r {
        width: 30%;
        margin-left: 40px;
        height: 100%;
        // background-color: #c60023;
      }
    }
  }
}
</style>
